module.exports = __webpack_public_path__ + "media/images/flags/1x1/phl-2bd9d10ba52fc47af9a95a673555305b.svg";